import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Wizard from '@ublique/components/Wizard'
import Stepper from '../components/Stepper'
import { Grid, Row } from '@ublique/components/Grid'
import { WizardTypes } from '../constants'
import { wizardStore } from 'services/state'
import '../index.scss'

const DocumentContainer = ({ open, close, data }) => {
  const [init, setInit] = useState(false)
  const { config, onSave, headingLabel } = data
  const enableRecap = config.enableRecap ?? true
  const { t } = useTranslation(['Wizard', 'WizardPlatform'])

  useEffect(() => {
    if (!init) {
      setInit(true)
      wizardStore.update((prevState) => ({
        ...prevState,
        creationMode: WizardTypes.SCENARIO_DOCUMENT
      }))
    }
  }, [])

  const onSubmit = useCallback(
    (formData) => {
      onSave(formData)
      close()
    },
    [onSave, close]
  )

  if (!open) {
    return null
  }

  return (
    <div id='wizard-container' className='document form-step'>
      <Wizard
        open={open}
        onClose={close}
        onRequestSubmit={onSave}
        headingLabel={t(headingLabel)}
      >
        <Grid id='wizard'>
          <Row className='wizard-row'>
            <div id='stepper' className='document'>
              <Stepper
                {...config}
                onSave={onSubmit}
                changeOpen={close}
                enableRecap={enableRecap}
              />
            </div>
          </Row>
        </Grid>
      </Wizard>
    </div>
  )
}

DocumentContainer.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  onSave: PropTypes.func,
  clones: PropTypes.array,
  extConfig: PropTypes.object,
  headingLabel: PropTypes.string
}

export default React.memo(DocumentContainer)
